import sizes from '../../theme/foundations/sizes'
import {pxToRem} from '../../utills/pxToRem'

export const cardStyles = {
    display: 'flex',
    justifyContent: 'end',
    gap: pxToRem(30),
    '.edit.primary-link, .remove.primary-link': {
        fontSize: pxToRem(10),
        fontWeight: 500,
        lineHeight: 'normal',
        letterSpacing: pxToRem(1),
        textDecorationLine: 'underline',
        color: 'cav_calltoaction_darkred',
        textTransform: 'uppercase',
        marginLeft: 0,
        [`@media (min-width: ${sizes.container.lg})`]: {
            fontSize: pxToRem(12)
        }
    }
}
